package com.solevo.dist.styles

import com.solevo.dist.theme.btnPrimaryColor
import com.solevo.dist.theme.btnPrimaryDisabledColor
import com.solevo.dist.theme.btnPrimaryHoverColor
import com.solevo.dist.theme.btnPrimaryTextColor
import com.solevo.dist.theme.textPrimaryColor
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.disabled
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

private object Tokens {
    val radiusMd = 10.px
    val spaceSm = 8.px
    val spaceMd = 12.px
    val transitionFast = "background-color .2s ease, color .2s ease, opacity .2s ease"
}

object UiStyles {

    object Labels {
        val label = CssStyle {
            base {
                Modifier
                    .fontFamily("Inter", "sans-serif")
                    .fontSize(12.px)
                    .lineHeight(24.px)
                    .color(textPrimaryColor)
                    .margin(bottom = Tokens.spaceSm)
                    .display(DisplayStyle.Block)
            }
        }
    }

    object Buttons {
        val primaryButton = CssStyle {
            base {
                Modifier
                    .width(320.px)
                    .padding(Tokens.spaceMd)
                    .fontFamily("Inter", "sans-serif")
                    .fontWeight(FontWeight.Bold)
                    .color(btnPrimaryTextColor)
                    .backgroundColor(btnPrimaryColor)
                    .borderRadius(Tokens.radiusMd)
                    .cursor(Cursor.Pointer)
                    .display(DisplayStyle.Flex)
                    .alignItems(AlignItems.Center)
                    .justifyContent(JustifyContent.Center)
                    .styleModifier {
                        property("transition", Tokens.transitionFast)
                    }
            }
            hover {
                Modifier.backgroundColor(btnPrimaryHoverColor)
            }
            active {
                Modifier.backgroundColor(btnPrimaryColor)
            }
            focusVisible {
                Modifier.outline(2.px, LineStyle.Solid, btnPrimaryHoverColor)
                    .outlineOffset(2.px)
            }
            disabled {
                Modifier
                    .backgroundColor(btnPrimaryDisabledColor)
                    .color(btnPrimaryTextColor)
                    .cursor(Cursor.NotAllowed)
                    .styleModifier { property("cursor", "not-allowed") }
            }
        }

        val primaryButtonFullWidth = CssStyle {
            base { Modifier.width(100.percent) }
        }

        val primaryButtonCompact = CssStyle {
            base { Modifier.width(240.px) }
        }
    }
}

